import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { TagInput } from '@/shared/ui/tag-input'
import { tagSuggestionsQueryOptions } from '../api/queries'

interface MeetingTagsInputProps {
  id?: string
  value: string[]
  onChange: (tags: string[]) => void
  disabled?: boolean
  'aria-invalid'?: boolean
  'aria-describedby'?: string
}

const SUGGEST_DEBOUNCE_MS = 300

// Поле тегов встречи: TagInput + серверные подсказки (дебаунс, популярные выше).
export function MeetingTagsInput({ value, onChange, ...rest }: MeetingTagsInputProps) {
  const [query, setQuery] = useState('')
  const [debounced, setDebounced] = useState('')

  useEffect(() => {
    const t = setTimeout(() => setDebounced(query.trim()), SUGGEST_DEBOUNCE_MS)
    return () => clearTimeout(t)
  }, [query])

  const suggestions = useQuery(tagSuggestionsQueryOptions(debounced))

  return (
    <TagInput
      {...rest}
      value={value}
      onChange={onChange}
      query={query}
      onQueryChange={setQuery}
      suggestions={(suggestions.data ?? []).map((s) => s.name)}
      placeholder="Компания-клиент или тема"
      maxTags={10}
    />
  )
}
